var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87672 16.7894C1.46342 17.0551 1.0473 17.0694 0.62837 16.8322C0.209457 16.595 0 16.2321 0 15.7437V1.35647C0 0.868044 0.209457 0.505232 0.62837 0.268032C1.0473 0.0308314 1.46342 0.0450912 1.87672 0.31081L13.1861 7.52596C13.5656 7.77017 13.7554 8.11284 13.7554 8.55397C13.7554 8.99507 13.5656 9.33516 13.1861 9.57423L1.87672 16.7894Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseDeviceIcon);
export default __webpack_public_path__ + "static/media/useDeviceIcon.416b0f74.svg";
export { ForwardRef as ReactComponent };